import React from "react";
import dialog from "../../common/utility/dialog";
import usuarioService from "../../service/seguridad/usuarioService";

import {
  Form,
  Divider,
  PageHeader,
  Button,
  message,
  Input,
} from "antd";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contraseniaActual: "",
      nuevaContrasenia: "",
      nuevaContraseniaConfirmar: "",
    };
  }

  handleSaveContrasenia = (values, form) => {

    
    if (values.NewPassword !== values.NewPasswordConfirm)
    {
        dialog.warning('Confirmación de nueva contraseña es incorrecto.');
        return;
    }

    dialog.confirm("¿Esta seguro de modificar la contraseña?", async () => {
        
        var response = await usuarioService.modificarContraseniaUsuario(values);
        if (response.status === 200) {
            message.success('Modificado correctamente.');
            localStorage.clear();
            return;
        }

        if (response.status === 400) {
            dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
            return;
        }

        dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
    });
};

handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
        
        console.log(values);
        if (!err){
            const form = {
                Password: values.contraseniaActual,
                NewPassword: values.nuevaContrasenia,
                NewPasswordConfirm: values.nuevaContraseniaConfirmar
            }
            this.handleSaveContrasenia(form, this.props.form);
        }
    });
}

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <PageHeader
          title="Cambiar Contraseña"
          extra={[
            <div key="1">
              <Button
                icon="save"
                type="primary"
                ghost
                onClick={this.handleOk}
              >
                Guardar
              </Button>
            </div>,
          ]}
        />
        <Divider />
        <Form>
          <div className="row mb-10">
            <div className="col-md-3">
              <Form.Item label="Contraseña Actual">
                {getFieldDecorator("contraseniaActual", {
                  initialValue: this.state.contraseniaActual,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                      whitespace: true,
                    },
                  ],
                })(
                  <Input
                    placeholder="Ingresar Contraseña Actual"
                    autoComplete="off"
                    type = "password"
                  />
                )}
              </Form.Item>
            </div>
          </div>

          <div className="row mb-10">
            <div className="col-md-3">
              <Form.Item label="Nueva Contraseña">
                {getFieldDecorator("nuevaContrasenia", {
                  initialValue: this.state.nuevaContrasenia,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                      whitespace: true,
                    },
                  ],
                })(
                  <Input
                    placeholder="Ingresar Nueva Contraseña"
                    autoComplete="off"
                    type = "password"
                  />
                )}
              </Form.Item>
            </div>
          </div>

          <div className="row mb-10">
            <div className="col-md-3">
              <Form.Item label="Confirmar Nueva Contraseña">
                {getFieldDecorator("nuevaContraseniaConfirmar", {
                  initialValue: this.state.nuevaContraseniaConfirmar,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                      whitespace: true,
                    },
                  ],
                })(
                  <Input
                    placeholder="Ingresar Nueva Contraseña"
                    autoComplete="off"
                    type = "password"
                  />
                )}
              </Form.Item>
            </div>
          </div>
        </Form>
      </div>
    );
  }
}

export default Form.create()(Index);
